import { AmplitudeProperties, ProviderName, AmplitudeEvents } from '@packlink/metrics';
import { getLengthValues } from './Filters.js';

const getResultsNames = results => Object.keys(results).filter(name => results[name]);
const areFiltersSelected = results => results.length > 0;
const getFiltersPayload = (carriers, collectionTypes, deliveryTypes, serviceDetails, transitHours, tagTypes) => {
  const payload = {};
  const carriersNames = getResultsNames(carriers);
  const collectionTypesNames = getResultsNames(collectionTypes);
  const deliveryTypesNames = getResultsNames(deliveryTypes);
  const serviceDetailsNames = getResultsNames(serviceDetails);
  const transitHoursNames = getResultsNames(transitHours);
  const tagTypesNames = getResultsNames(tagTypes);
  if (areFiltersSelected(carriersNames)) {
    payload[AmplitudeProperties.CARRIER] = carriersNames;
  }
  if (areFiltersSelected(collectionTypesNames)) {
    payload[AmplitudeProperties.COLLECTION_TYPE] = collectionTypesNames;
  }
  if (areFiltersSelected(deliveryTypesNames)) {
    payload[AmplitudeProperties.DELIVERY_TYPE] = deliveryTypesNames;
  }
  if (areFiltersSelected(serviceDetailsNames)) {
    payload[AmplitudeProperties.DETAIL_OF_SERVICE] = serviceDetailsNames;
  }
  if (areFiltersSelected(transitHoursNames)) {
    payload[AmplitudeProperties.TRANSIT_TIME] = transitHoursNames;
  }
  if (areFiltersSelected(tagTypesNames)) {
    payload[AmplitudeProperties.TAGS] = tagTypesNames;
  }
  return payload;
};
const getMetrics = (carriers, collectionTypes, deliveryTypes, serviceDetails, transitHours, tagTypes) => {
  const payloadFilters = getFiltersPayload(carriers, collectionTypes, deliveryTypes, serviceDetails, transitHours, tagTypes);
  const isPayload = getLengthValues(payloadFilters) === 0;
  const metrics = {
    providerName: ProviderName.AMPLITUDE,
    eventName: isPayload ? AmplitudeEvents.SERVICE_LIST_APPLY_NO_FILTERS : AmplitudeEvents.SERVICE_LIST_APPLY_FILTERS
  };
  return isPayload ? {
    ...metrics
  } : {
    ...metrics,
    payload: {
      ...payloadFilters
    }
  };
};

export { getFiltersPayload, getMetrics };
//# sourceMappingURL=PayloadFilters.js.map
